import { createRouter, createWebHistory } from 'vue-router'
import { applyRouteTitle } from './title'

const HomeView = () => import('../views/HomeView.vue')

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/profile',
      name: 'profile',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/ProfileView.vue')
    },
    {
      path: '/settings',
      name: 'settings',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/SettingsView.vue')
    },
    {
      path: '/agent/:conversationId?',
      name: 'agent',
      meta: {
        title: 'Mobidic Agent | Mobidic',
        fullHeight: true
      },
      // Admin-only data-analysis agent (Claude); the API enforces ROLE_ADMIN.
      component: () => import('../views/AgentChatView.vue')
    },
    {
      path: '/accounts',
      name: 'accounts',
      meta: {
        title: 'Conti | Mobidic'
      },
      component: () => import('../views/Accounts/AccountsView.vue')
    },
    {
      path: '/import',
      name: 'import',
      children: [
        {
          path: 'file',
          name: 'importFile',
          meta: {
            title: 'Import File | Mobidic'
          },
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Import/FileView.vue')
        },
        {
          path: 'bank-statement',
          name: 'bankStatementImport',
          meta: {
            title: 'Import Bank Statement | Mobidic'
          },
          component: () => import('../views/Import/BankStatementImportView.vue')
        },
        {
          path: 'manual-transaction',
          name: 'importManualTransaction',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Import/ManualTransactionView.vue')
        },
        {
          path: 'portfolio-manual-entry',
          name: 'portfolioManualEntry',
          meta: {
            title: 'Gestione manuale titoli | Mobidic'
          },
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Import/PortfolioManualEntryView.vue')
        },
        {
          path: 'list',
          name: 'importList',
          // La tabella occupa l'altezza della finestra e scorre al proprio interno.
          meta: { fullHeight: true },
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Import/ListView.vue')
        },
        {
          path: 'detail/:importId',
          name: 'importDetail',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Import/DetailView.vue')
        }
      ]
    },
    {
      path: '/analyze',
      name: 'analyze',
      children: [
        {
          path: '/analyze/erp-generic-report',
          name: 'analyzeErpGenericReport',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Analyze/ErpGenericReportView.vue')
        },
        {
          path: 'erp-report/:erp',
          name: 'analyzeErpReport',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Analyze/ErpReportView.vue')
        },
        {
          path: 'scheda-contabile',
          name: 'analyzeSchedaContabile',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Analyze/SchedaContabileView.vue')
        },
        {
          path: 'progressive-calculation',
          name: 'analyzeProgressiveCalculation',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Analyze/ProgressiveCalculationView.vue')
        },
        {
          path: 'export-cash-activity/eur',
          name: 'analyzeExportCashActivityEur',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Analyze/ExportCashActivityEurView.vue')
        },
        {
          path: 'export-cash-activity/non-eur',
          name: 'analyzeExportCashActivityNonEur',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Analyze/ExportCashActivityNonEurView.vue')
        },
        {
          path: 'transaction-error',
          name: 'analyzeTransactionError',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Analyze/TransactionErrorView.vue')
        },
        {
          path: 'portfolio-performance',
          name: 'portfolioPerformance',
          component: () => import('../views/Analyze/PortfolioPerformanceView.vue')
        }
      ]
    },
    {
      path: '/stock',
      name: 'stock',
      children: [
        {
          path: 'stock',
          name: 'analyzeStock',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Stock/StockView.vue')
        },
        {
          path: 'stock-opzioni-titoli',
          name: 'analyzeStockOpzioniTitoli',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Stock/StockOpzioniTitoliView.vue')
        },
        {
          path: 'deposit-funds',
          name: 'depositFunds',
          // route level code-splitting
          // this generates a separate chunk (About.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('../views/Stock/DepositFundsView.vue')
        },
        {
          path: 'strumenti-valutari',
          name: 'strumentiValutari',
          component: () => import('../views/Stock/StrumentiValutariView.vue')
        }
      ]
    },
    {
      path: '/documentation',
      name: 'documentation',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/DocumentationView.vue')
    },
    {
      path: '/documentation/:slug',
      name: 'documentationDetail',
      // Uses the same component but with a parameter
      component: () => import('../views/DocumentationView.vue')
    }
  ]
})

// Il titolo segue la rotta più annidata che lo definisce, altrimenti 'Mobidic'.
router.beforeEach((to) => {
  applyRouteTitle(to)
})

export default router
